import React from 'react';
import clx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { withStyles, Button, Box } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    height: 200,
    backgroundColor: theme.palette.grey[400],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),

    '@media print': {
      backgroundColor: 'red',
    },
  },
  imgHeight: {
    [theme.breakpoints.up('sm')]: {
      height: 400,
    },
  },
});

const CottageInfo = ({ classes, cottagePic, id, taller }) => (
  <Box displayPrint="none" boxShadow={3}>
    <Box
      style={{ backgroundImage: `url('${cottagePic}')` }}
      className={clx(classes.root, taller ? classes.imgHeight : null)}
      component="div"
    >
      {id && (
        <Button
          color="primary"
          component="a"
          variant="contained"
          href={`/sv/stuga/${id}`}
          target="_blank"
        >
          <FormattedMessage id="bookingForm.viewAd" defaultMessage="View ad" />
          <ChevronRight />
        </Button>
      )}
    </Box>
  </Box>
);

CottageInfo.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  cottagePic: PropTypes.string,
  id: PropTypes.number,
  taller: PropTypes.bool,
};

export default withStyles(styles)(CottageInfo);
